import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class RoleService {

  constructor() { }

  private roleAnnouncedSource = new BehaviorSubject<string>(null);
  // Observable string streams
  roleAnnounced$ = this.roleAnnouncedSource.asObservable();
  // Service message commands
  announceRole(role: string) {
    this.roleAnnouncedSource.next(role);
  }

}

